import { useMemo } from 'react';
import { Typography } from 'seagull';
import { LegalTerms } from "../../../../components/AgreementStudioPage/AgreementStudioModal/LegalTerms/LegalTerms";
import LegalTermsDropdownOld from "../../../../components/LegalTermsDropdownOld/LegalTermsDropdownOld";
import { useStore, useStoreActions } from "../../../../contexts";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { legalTermsModel } from "../../../../models";
import { selectors } from "../../../../store/state-selectors";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getLegalTermsOld } from "../EditDraftsTable.utils";
import { jsx as _jsx } from "react/jsx-runtime";
const getLegalTermErrors = legalTerms => {
  return legalTerms.map(legalTerm => {
    var _legalTerm$termsOfSer;
    const errors = {};
    if (legalTerm === null) {
      errors.legalTermField = 'Please choose a document';
    }
    if ((legalTerm === null || legalTerm === void 0 || (_legalTerm$termsOfSer = legalTerm.termsOfService) === null || _legalTerm$termsOfSer === void 0 ? void 0 : _legalTerm$termsOfSer.type) === 'explicitApproval') {
      var _legalTerm$termsOfSer2, _legalTerm$termsOfSer3;
      if (!((_legalTerm$termsOfSer2 = legalTerm.termsOfService.explicitApproval.statement) !== null && _legalTerm$termsOfSer2 !== void 0 && _legalTerm$termsOfSer2.trim())) {
        errors.explicitApproval = 'Please enter a checkbox statement';
      } else if (((_legalTerm$termsOfSer3 = legalTerm.termsOfService.explicitApproval.statement) === null || _legalTerm$termsOfSer3 === void 0 ? void 0 : _legalTerm$termsOfSer3.length) > 120) {
        errors.explicitApproval = 'The statement can be up to 120 characters';
      }
    }
    return errors;
  });
};
const hasLegalTermsErrors = legalTerms => {
  return legalTerms.length === 0 || getLegalTermErrors(legalTerms).some(error => error.legalTermField || error.explicitApproval);
};
const getLegalTermsIdOld = draft => {
  const legalTerms = draft.legalTermsOld();
  return legalTerms != null && 'libraryLegalTermsId' in legalTerms ? legalTerms.libraryLegalTermsId : null;
};
function TermsOfServiceModalContentOld(_ref) {
  let {
    draft,
    setDraft
  } = _ref;
  const {
    fetchLegalTerms
  } = useStoreActions();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const worksAt = useStore(selectors.user.business);
  const businessAndDraftLegalDocs = useMemo(() => {
    const legalTerms = draft.legalTermsOld();
    if (legalTermsDocuments == null) return [];
    if (legalTermsDocuments.some(_ref2 => {
      let {
        id
      } = _ref2;
      return id === getLegalTermsIdOld(draft);
    })) return legalTermsDocuments;
    if ((legalTerms === null || legalTerms === void 0 ? void 0 : legalTerms.type) === 'libraryLegalTermsId') {
      return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTermsOld(legalTerms)]);
    }
    if (legalTermsDocuments.some(_ref3 => {
      let {
        id
      } = _ref3;
      return id === getLegalTermsIdOld(draft);
    })) {
      return legalTermsDocuments;
    }
    return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTermsOld(legalTerms)]);
  }, [legalTermsDocuments, draft]);
  const fileId = useMemo(() => {
    const {
      legalTermsDocumentId
    } = (worksAt === null || worksAt === void 0 ? void 0 : worksAt.settings) || {};
    const legalTermsId = getLegalTermsIdOld(draft);
    return legalTermsId || legalTermsDocumentId || null;
  }, [worksAt, draft]);
  return /*#__PURE__*/_jsx(LegalTermsDropdownOld, {
    legalTerms: businessAndDraftLegalDocs,
    selectedLegalTerms: businessAndDraftLegalDocs.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === fileId;
    }),
    onUpload: fetchLegalTerms,
    onChange: document => {
      setDraft(draft.setLegalTermsDocuments([legalTermsModel.toRelationshipLegalTermsDocuments(document)]));
    },
    onChangeOld: id => {
      setDraft(draft.setLegalTermsOld({
        type: 'libraryLegalTermsId',
        libraryLegalTermsId: id
      }));
    }
  });
}
function TermsOfServiceModalContent(_ref5) {
  let {
    draft,
    setDraft,
    wasSubmitted
  } = _ref5;
  const legalTermsDocuments = draft.legalTermsDocuments();
  const errors = useMemo(() => wasSubmitted ? getLegalTermErrors(legalTermsDocuments) : [], [wasSubmitted, legalTermsDocuments]);
  const onAgreementLegalTermsChange = updatedLegalTerms => {
    setDraft(draft.setLegalTermsDocuments(updatedLegalTerms));
  };
  return /*#__PURE__*/_jsx(LegalTerms, {
    withTitle: false,
    withExplicitApproval: true,
    agreementLegalTerms: legalTermsDocuments,
    onAgreementLegalTermsChange: onAgreementLegalTermsChange,
    errors: errors
  });
}
export default function TermsOfServiceCell(_ref6) {
  var _legalTermsOld$name;
  let {
    isDisabled,
    disabledTooltip,
    draft,
    index,
    onOpenModal
  } = _ref6;
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const legalTermsOld = useMemo(() => getLegalTermsOld(draft, legalTermsDocuments), [draft, legalTermsDocuments]);
  const agreementLegalTermsDocuments = draft.legalTermsDocuments();
  const onClick = () => onOpenModal({
    submitOnNotDirty: MULTIPLE_LEGAL_TERMS_DOCUMENTS,
    shouldSubmit: async editedDraft => {
      if (!MULTIPLE_LEGAL_TERMS_DOCUMENTS) return true;
      return !hasLegalTermsErrors(editedDraft.legalTermsDocuments());
    },
    width: MULTIPLE_LEGAL_TERMS_DOCUMENTS ? '700px' : undefined,
    maxHeight: MULTIPLE_LEGAL_TERMS_DOCUMENTS ? '600px' : undefined,
    renderContent: _ref7 => {
      let {
        draft,
        setDraft,
        wasSubmitted
      } = _ref7;
      return {
        title: 'Terms of service',
        testid: 'edit-terms-modal',
        content: MULTIPLE_LEGAL_TERMS_DOCUMENTS ? /*#__PURE__*/_jsx(TermsOfServiceModalContent, {
          draft: draft,
          setDraft: setDraft,
          wasSubmitted: wasSubmitted
        }) : /*#__PURE__*/_jsx(TermsOfServiceModalContentOld, {
          draft: draft,
          setDraft: setDraft
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  const getLegalTermsName = () => {
    var _agreementLegalTermsD, _agreementLegalTermsD2;
    if (agreementLegalTermsDocuments.length > 1) {
      return "".concat(agreementLegalTermsDocuments.length, " documents");
    }
    return (_agreementLegalTermsD = agreementLegalTermsDocuments === null || agreementLegalTermsDocuments === void 0 || (_agreementLegalTermsD2 = agreementLegalTermsDocuments[0]) === null || _agreementLegalTermsD2 === void 0 ? void 0 : _agreementLegalTermsD2.displayName) !== null && _agreementLegalTermsD !== void 0 ? _agreementLegalTermsD : '';
  };
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-terms-of-service-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "terms-of-service-".concat(index),
      children: MULTIPLE_LEGAL_TERMS_DOCUMENTS ? getLegalTermsName() : (_legalTermsOld$name = legalTermsOld === null || legalTermsOld === void 0 ? void 0 : legalTermsOld.name) !== null && _legalTermsOld$name !== void 0 ? _legalTermsOld$name : ''
    })
  });
}